import { render, staticRenderFns } from "./YoutubePopup.vue?vue&type=template&id=45920343&scoped=true&"
import script from "./YoutubePopup.vue?vue&type=script&lang=ts&"
export * from "./YoutubePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45920343",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDialog,VForm})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45920343')) {
      api.createRecord('45920343', component.options)
    } else {
      api.reload('45920343', component.options)
    }
    module.hot.accept("./YoutubePopup.vue?vue&type=template&id=45920343&scoped=true&", function () {
      api.rerender('45920343', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/digitalSignage/YoutubePopup.vue"
export default component.exports